<template>
    <v-autocomplete :items="$store.state.fonts || []" :label="label" v-model="font" color="zoezi-edit-color" item-color="zoezi-edit-color" @input="$emit('input', font)"  class="zoezi-edit-font" :hint="hint" clearable />
</template>

<script>
export default {
    name: 'zoezi-font-setting',

    props: ['value', 'label', 'hint'],

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.font = value;
            }
        }
    },

    data: () => ({
        font: null
    }),

    mounted() {
        if (!this.$store.state.fonts) {
            this.$api.get('/api/homepage/fonts/get').then(fonts => this.$store.commit('setFonts', fonts));
        }
    }
}
</script>
